import axios from 'axios';

export default {
    send(context, data) {

        var options = {
            url: window.apiUrl + '/message',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

    delete(context, data) {

        var options = {
            url: window.apiUrl + '/message',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'DELETE'
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    undelete(context, data) {

        var options = {
            url: window.apiUrl + '/message',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'PUT'
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },


    reply(context, data) {

        var options = {
            url: window.apiUrl + '/message/reply',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

    getUnread(context) {

        var url = window.apiUrl + '/messages/unread/' + localStorage.user_id;

        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;
        });

    },


    get(context, page, direction, deleted) {
        var url = window.apiUrl + '/messages/' + localStorage.user_id + '?page=' + page + '&direction=' + direction + '&deleted=' + deleted;
       var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;
        });

    },
    getReplies(context, messageId) {

       var options = {
            url: window.apiUrl + '/replies/' + messageId,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;
        });

    },
    markAsRead(context, messageId) {
        var data = {
            uuid: window.localStorage.uuid,
            messageId: messageId
        }
        var options = {
            url: window.apiUrl + '/message',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'PATCH'
        };
        return axios.request(options).then(function(response) {
            return response;
        });

    }


};



// WEBPACK FOOTER //
// ./src/services/messages/index.js